
import { Component, Prop, Vue } from 'vue-property-decorator';

import { PREVIOUS_RETAILER_COOKIE, PREVIOUS_RETAILER_COOKIE_MAX_AGE_SECONDS } from '../services/PreviousRetailerCookie';

/**
 * Renders nothing. Placed on retailer pages to save the organization id of the store
 * in a cookie, which the central site header reads to show the last visited store.
 */
@Component({
    render(h) {
        return h();
    }
})
class RememberRetailerVisited extends Vue {
    @Prop({ default: '' }) public organizationId!: string;

    mounted() {
        if (this.organizationId) {
            document.cookie = `${PREVIOUS_RETAILER_COOKIE}=${this.organizationId}; max-age=${PREVIOUS_RETAILER_COOKIE_MAX_AGE_SECONDS}; path=/; SameSite=Lax`;
        }
    }
}

export default RememberRetailerVisited;
